import React, { createContext, useContext, useMemo } from 'react';
import useDeepCompare from '../hooks/useDeepCompare';

export const DataContext = createContext();

export const DataProvider = ({
	children,
	ion,
	debug,
	offeringOptions,
	sessionId,
}) => {
	// offeringOptions is a complex object that can't be used directly in a useMemo, so this will let us know if it needs updating.
	const memoizedOfferingOptions = useDeepCompare(offeringOptions);
	const dataValue = useMemo(() => ({
		offeringOptions,
		ion,
		sessionId,
		debug,
	}), [memoizedOfferingOptions, ion.id, debug, sessionId]);
	return (
		<DataContext.Provider value={dataValue}>
			{children}
		</DataContext.Provider>
	);
};

export const useDataContext = () => {
	const context = useContext(DataContext);
	if (!context) {
		throw new Error('useDataContext must be used within a DataProvider');
	}
	return context;
};
